import { root } from '@estee/elc-universal-utils';

import { IServiceAppConfig } from '~domain/entities/IConfig';
import { AuthenticatedRepository, authStates } from '~repositories/AuthenticatedRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AccountService';

export class AccountPageLoadedUseCase {
    private authenticatedRepository: AuthenticatedRepository;
    private accountRoutes: IServiceAppConfig;

    constructor() {
        this.authenticatedRepository = diContainer.get(serviceNames.authenticatedRepository);
        const config = diContainer.get(serviceNames.config);
        this.accountRoutes = config?.accountRoutes;
    }

    public async execute() {
        await this.authenticatedRepository.fetchUserAuthState();
        const { authState } = this.authenticatedRepository;

        if (authState !== authStates.SIGNEDIN) {
            root.location.href = this.accountRoutes?.signInPath;
        }
    }
}
